import React from 'react';
import {PropTypes} from 'prop-types';
import {ToString} from '../../shared/utils';
import {SimpleTooltip} from '../../shared/tooltip';

export class FlagComponent extends React.Component {

    shouldComponentUpdate(nextProps) {
        const props = this.props;

        const result = 
            (nextProps.countryId != props.countryId) ||
            (nextProps.countryName != props.countryName) ||
            (nextProps.lastIP != props.lastIP);
        
        return result;
    }

    render() {
        const self = this;

        const data = {
            CountryId: ToString(self.props.countryId),
            CountryName: ToString(self.props.countryName),
            LastIP: ToString(self.props.lastIP)
        }

        if (!Boolean(data.CountryId)) {
            return null;
        }

        return (
            <SimpleTooltip 
                title={
                    <div className="text-left">
                        <span className={`flag flag-${data.CountryId.toLowerCase()}`} />&nbsp;{data.CountryId} ({data.CountryName})
                        {Boolean(data.LastIP) && <div>IP: {data.LastIP}</div>}
                    </div>
                } 
                isHtml
                placement="right"
            >
                <span className={`flag flag-${data.CountryId.toLowerCase()}`} />
            </SimpleTooltip>
        )
    }
}
FlagComponent.propTypes = {
    countryId: PropTypes.string,
    countryName: PropTypes.string,
    lastIP: PropTypes.string,
}